import Mousetrap from 'mousetrap';
import { Sentry } from 'app/utils/sentry';
import { pubSub } from 'utils/pubSub';
import * as conversationActions from '../../../components/conversation/actions/conversation';
import { notificationActions } from '../../../components/notifications/actions/notification';
import { presenceActions } from '../../../components/presence/actions/presenceActions';
import { composeEmailActions } from '../../../components/shared/composeEmail/actions/composeEmailActions';
import * as telephonyActions from '../../../components/telephony/actions/telephony';
import { keyboardShortcutsActions } from './actions/keyboardShortcuts';
const { presenceSetStatus } = presenceActions;
const { keyboardShortcutsStart, keyboardShortcutsStop } = keyboardShortcutsActions;
const { composeEmailOpenModal } = composeEmailActions;
const { conversationClaim, conversationRespondeToOfferAccepted, conversationRespondeToTransferOfferAccepted, conversationRespondeToOfferRejected, conversationRespondeToTransferOfferRejected, } = conversationActions.actions;
const { notificationRemoveByType } = notificationActions;
const { telephonySetHold, telephonySetMute, telephonyOpenDropdown } = telephonyActions.actions;
export const keyboardShortcutsMiddleware = () => (store) => {
    const next = store.dispatch;
    const initKeyboardShortcuts = () => {
        Mousetrap.prototype.stopCallback = function (e, elm, combo) {
            // if the element has the class "mousetrap" then no need to stop
            if ((' ' + elm.className + ' ').indexOf(' mousetrap ') > -1) {
                return false;
            }
            // stop for input, select, and textarea
            if (combo === '/') {
                return (elm.tagName == 'INPUT' ||
                    elm.tagName == 'SELECT' ||
                    elm.tagName == 'TEXTAREA' ||
                    (elm.contentEditable && elm.contentEditable == 'true'));
            }
            return false;
        };
        // Open compose email.
        Mousetrap.bind(['ctrl+alt+n'], () => {
            next(composeEmailOpenModal());
        });
        // Claim conversation.
        Mousetrap.bind(['ctrl+alt+c'], () => {
            const metaConversation = store.getState().conversation.metaConversation;
            if (metaConversation.conversation.id !== null &&
                metaConversation.isAssignedToMe === false) {
                next(conversationClaim({ csid: metaConversation.conversation.id }));
            }
        });
        // Search open.
        Mousetrap.bind(['/'], (e) => {
            e.stopPropagation();
            e.preventDefault();
            pubSub.publish('toggleGlobalSearch', { isOpen: true });
        });
        // Toggle mute current call.
        Mousetrap.bind(['ctrl+alt+m'], (e) => {
            e.stopPropagation();
            e.preventDefault();
            const telephony = store.getState().telephony;
            let activePhoneMetaConversation = null;
            const metaConversation = store.getState().conversation.metaConversation;
            if (metaConversation.conversation.is_closed === false &&
                metaConversation.isAssignedToMe === true &&
                (metaConversation.conversation.initial_channel === 'pstnphone' ||
                    metaConversation.conversation.initial_channel === 'callback')) {
                activePhoneMetaConversation = metaConversation;
            }
            if (telephony.currentCall !== null && activePhoneMetaConversation) {
                next(telephonySetMute({
                    setTo: !telephony.isOnMute,
                    csid: activePhoneMetaConversation.conversation.id,
                }));
                //bindActionToPromise(next, telephonySetMute)
            }
        });
        // Toggle hold on current call.
        Mousetrap.bind(['ctrl+alt+h'], (e) => {
            e.stopPropagation();
            e.preventDefault();
            const telephony = store.getState().telephony;
            let activePhoneMetaConversation = null;
            const metaConversation = store.getState().conversation.metaConversation;
            if (metaConversation.conversation.is_closed === false &&
                metaConversation.isAssignedToMe === true &&
                (metaConversation.conversation.initial_channel === 'pstnphone' ||
                    metaConversation.conversation.initial_channel === 'callback')) {
                activePhoneMetaConversation = metaConversation;
            }
            if (telephony.currentCall !== null && activePhoneMetaConversation) {
                next(telephonySetHold({
                    setTo: !telephony.isOnHold,
                    csid: activePhoneMetaConversation.conversation.id,
                    requesterId: activePhoneMetaConversation.requester.id,
                }));
            }
        });
        // Accept conversation offer.
        Mousetrap.bind(['ctrl+alt+a'], () => {
            const conversationOffers = store.getState().offers.conversationOffers;
            if (conversationOffers.length > 0) {
                const conversationOffer = conversationOffers[0];
                const csid = conversationOffer.csid !== undefined ? conversationOffer.csid : null;
                const isInternal = conversationOffer.isInternal;
                const transferType = conversationOffer.transferType
                    ? conversationOffer.transferType
                    : null;
                if (csid) {
                    if (transferType) {
                        next(conversationRespondeToTransferOfferAccepted({
                            csid: csid,
                            did_accept: true,
                            isInternal: isInternal,
                        }));
                    }
                    else {
                        next(conversationRespondeToOfferAccepted({
                            csid: csid,
                            did_accept: true,
                            isInternal: isInternal,
                        }));
                    }
                    next(notificationRemoveByType({ type: 'conversationOffer_' + csid })); // Remove any offer notification.
                }
            }
        });
        // Reject conversation offer.
        Mousetrap.bind(['ctrl+alt+r'], () => {
            const conversationOffers = store.getState().offers.conversationOffers;
            if (conversationOffers.length > 0) {
                const conversationOffer = conversationOffers[0];
                const csid = conversationOffer.csid !== undefined ? conversationOffer.csid : null;
                const isInternal = conversationOffer.isInternal;
                const transferType = conversationOffer.transferType
                    ? conversationOffer.transferType
                    : null;
                if (csid) {
                    if (transferType) {
                        next(conversationRespondeToTransferOfferRejected({
                            csid: csid,
                            did_accept: false,
                            isInternal: isInternal,
                        }));
                    }
                    else {
                        next(conversationRespondeToOfferRejected({
                            csid: csid,
                            did_accept: false,
                            isInternal: isInternal,
                        }));
                    }
                    next(notificationRemoveByType({ type: 'conversationOffer_' + csid })); // Remove any offer notification.
                }
            }
        });
        // Toggle presence (Working/Away).
        Mousetrap.bind(['ctrl+alt+w'], () => {
            // Toggle presence.
            const presence = store.getState().presence.presence;
            const newStatus = presence.status === 'working' ? 'away' : 'working';
            next(presenceSetStatus(newStatus));
        });
        // Open dialer dropdown and set focus on search field.
        Mousetrap.bind(['ctrl+alt+p'], () => {
            next(telephonyOpenDropdown());
        });
        // Set focus to note on conversation view.
        Mousetrap.bind(['ctrl+alt+b'], () => {
            // @TODO
        });
        // Open tags dropdown and set focus on the tag list on conversation view.
        Mousetrap.bind(['ctrl+alt+y'], () => {
            // @TODO
        });
        // Open follow-up dropdown on conversation view.
        Mousetrap.bind(['ctrl+alt+f'], () => {
            // @TODO
        });
    };
    const removeKeyboardShortcuts = () => {
        Mousetrap.reset();
    };
    return (next) => (action) => {
        try {
            switch (action.type) {
                case keyboardShortcutsStart.toString(): {
                    initKeyboardShortcuts();
                    break;
                }
                case keyboardShortcutsStop.toString(): {
                    removeKeyboardShortcuts();
                    break;
                }
            }
        }
        catch (exception) {
            Sentry.captureException(new Error('KeyboardShortcuts: middleware exception catched'));
        }
        return next(action);
    };
};
